import { motion } from "framer-motion";
import { HandHeart, Accessibility, Brain, HeartPulse, ClipboardList, Pill } from "lucide-react";
import { SERVICES } from "@/lib/content";
import { Eyebrow, Reveal } from "./Reveal";
import { photoSet } from "@/lib/img";

const ICONS = [HandHeart, Accessibility, Brain, HeartPulse, ClipboardList, Pill];

export const Services = () => (
  <section id="services" className="py-20 sm:py-28 bg-[#FFFDF8] border-y border-[#154F49]/10 no-print" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32 space-y-6">
          <Reveal className="space-y-4">
            <Eyebrow>Core services</Eyebrow>
            <h2 className="font-serif text-4xl sm:text-5xl text-[#154F49] leading-[1.04]">The everyday skills that make care feel <em className="text-[#9B742A]">human.</em></h2>
            <p className="text-[#465F57] leading-relaxed">Each service is delivered within the caregiver's training, credentials and authorised scope, and the agreed care plan.</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="relative rounded-t-[200px] rounded-b-[28px] overflow-hidden aspect-[5/4] lg:aspect-[4/5]">
              <img src="/images/vitals.jpg" srcSet={photoSet("/images/vitals.jpg", 1200)} sizes="(min-width: 1024px) 40vw, 100vw" decoding="async" alt="Caregiver checking an older adult's vital signs" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              <div aria-hidden className="absolute inset-0 ring-1 ring-inset ring-[#154F49]/10 rounded-t-[200px] rounded-b-[28px]" />
            </div>
          </Reveal>
        </div>
      </div>
      <ol className="lg:col-span-7 divide-y divide-[#154F49]/15 border-t border-[#154F49]/15">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={s.title} delay={i * 0.05}>
              <motion.li whileHover={{ x: 10 }} transition={{ type: "spring", stiffness: 260, damping: 24 }} className="group py-8 grid grid-cols-[auto_1fr] sm:grid-cols-[72px_1fr_auto] gap-5 items-start" data-testid={`service-item-${i + 1}`}>
                <span className="font-serif text-3xl text-[#CDA34F] tabular-nums">0{i + 1}</span>
                <div>
                  <h3 className="font-serif text-3xl sm:text-4xl text-[#154F49] group-hover:text-[#9B742A] transition-colors">{s.title}</h3>
                  <p className="mt-2 text-[#465F57] leading-relaxed max-w-lg">{s.copy}</p>
                </div>
                <span className="hidden sm:flex w-14 h-14 rounded-full border border-[#154F49]/20 items-center justify-center text-[#154F49] group-hover:bg-[#154F49] group-hover:text-[#FBF8F1] transition-colors">
                  <Icon className="w-6 h-6" />
                </span>
              </motion.li>
            </Reveal>
          );
        })}
      </ol>
    </div>
  </section>
);
